const AuthLogin = () => import(/* webpackPrefetch: true, webpackChunkName: "add-pet" */ '@/app/views/auth-view/components/auth-login/auth-login.vue');
const AuthPassword = () => import(/* webpackPrefetch: true, webpackChunkName: "auth-password" */ '@/app/views/auth-view/components/auth-password/auth-password.vue');
const AuthRegisterContainer = () => import(/* webpackPrefetch: true, webpackChunkName: "auth-register-continer" */ '@/app/views/auth-view/components/auth-register/containers/auth-register-container/auth-register-container.vue');
const TheFooter = () => import(/* webpackPrefetch: true, webpackChunkName: "the-footer" */ '@/app/views/main-view/_shared/the-footer/the-footer.vue');

export default {
    name: 'AuthContainer',
    components: {
        AuthLogin,
        AuthRegisterContainer,
        AuthPassword,
        TheFooter
    },
    data() {
        return {}
    },
    computed: {
        selectedRoute(){
            let selectedComponent = '';

            if (this.$route.path === '/authenticate') {
                selectedComponent = 'auth-password';
            } else {
                selectedComponent = 'auth-login'
            }

            return selectedComponent;
        }
    }
}